export const USER_INFO_SET_USER_INFO = "USER_INFO_SET_USER_INFO";
export const USER_INFO_SET_LOADING = "USER_INFO_SET_LOADING";
export const USER_INFO_SET_LOADING_LOGIN = "USER_INFO_SET_LOADING_LOGIN";
